import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Document, Font, Page, PDFViewer, StyleSheet, Text, View } from '@react-pdf/renderer';
import { BillTo, BorderPolygon, ItemsTable, Number, Title } from './components';
;
Font.register({
    family: 'Roboto',
    fonts: [
        { src: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Me5WZLCzYlKw.ttf', fontStyle: 'normal', fontWeight: 'normal', },
        { src: 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtvAx05IsDqlA.ttf', fontWeight: 700, },
        { src: 'https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1Mu52xPKTM1K9nz.ttf', fontStyle: 'italic', fontWeight: 'normal', },
    ],
});
export const InvoiceDocument = ({ invoice, wholesaler, pharmacy, }) => {
    const { invoiceNumber, } = invoice;
    const styles = StyleSheet.create({
        page: {
            display: 'flex',
            flexDirection: 'column',
            padding: 30,
        },
        footerContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            marginTop: 16,
        },
        footer: {
            fontSize: 9,
            textAlign: 'center',
            textTransform: 'uppercase',
            fontStyle: 'italic',
            fontFamily: 'Roboto',
        },
    });
    return (_jsx(PDFViewer, { width: '100%', height: '100%', children: _jsx(Document, { title: `Invoice ${invoiceNumber}.pdf`, children: _jsxs(Page, { size: 'A4', wrap: false, style: styles.page, children: [_jsx(BorderPolygon, { border: 'top' }), _jsx(Title, { title: `Invoice #${invoiceNumber}` }), _jsx(Number, { invoice: invoice }), _jsx(BillTo, { wholesaler: wholesaler, pharmacy: pharmacy }), _jsx(ItemsTable, { invoice: invoice }), _jsx(View, { style: styles.footerContainer, children: _jsx(Text, { style: styles.footer, children: "Thank you for your business!" }) }), _jsx(BorderPolygon, { border: 'bottom' })] }) }) }));
};
